import isPaymentScheduleEnabled from 'checkout/selectors/payment/paymentSchedule/isPaymentScheduleEnabled'
import FormatCurrency from 'components/Common/FormatCurrency'
import MessageBanner from 'components/Luxkit/Banners/MessageBanner'
import TextLink from 'components/Luxkit/TextLink'
import FormatPercent from 'components/utils/Formatters/FormatPercent'
import ModalContext from 'contexts/ModalContext'
import withMountGuard from 'hocs/withMountGuard'
import { useAppSelector } from 'hooks/reduxHooks'
import React, { useCallback, useContext } from 'react'
import TourDepositInfoModal from './TourDepositInfoModal'

interface Props {
  offer: App.Tours.TourV2Offer
}

function TourDepositBanner({ offer }: Props) {
  const deposit = offer.paymentScheduleTemplate?.schedules[0]

  const showModal = useContext(ModalContext)
  const openDepositInfoModal = useCallback(async() => {
    if (offer.paymentScheduleTemplate) {
      showModal(<TourDepositInfoModal paymentScheduleTemplate={offer.paymentScheduleTemplate} />)
    }
  }, [offer.paymentScheduleTemplate, showModal])

  if (!deposit) return null

  return <MessageBanner
    kind="promotional-primary"
    description={<>
      <b>Deposits available</b>: Book now from just{' '}
      {deposit.amountType === 'percentage' && <FormatPercent value={deposit.amountValue} />}
      {deposit.amountType === 'fixed_amount' && <FormatCurrency value={deposit.amountValue} />}.{' '}
      <TextLink onClick={openDepositInfoModal}>Find out more</TextLink>
    </>}
  />
}

export default withMountGuard(() => {
  return useAppSelector(isPaymentScheduleEnabled)
})(TourDepositBanner)
